/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CheckStackInIssuesRequest } from '../model'
// @ts-ignore
import type { YardIssueResponse } from '../model'
// @ts-ignore
import type { StackInIssueCheckResponse } from '../model'
/**
 * YardIssuesApi - axios parameter creator
 */
export const YardIssuesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CheckStackInIssuesRequest} [checkStackInIssuesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkStackInIssues: async (
      checkStackInIssuesRequest?: CheckStackInIssuesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardIssues/CheckStackInIssues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkStackInIssuesRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardIssues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardIssues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * YardIssuesApi - functional programming interface
 */
export const YardIssuesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = YardIssuesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CheckStackInIssuesRequest} [checkStackInIssuesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkStackInIssues(
      checkStackInIssuesRequest?: CheckStackInIssuesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StackInIssueCheckResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkStackInIssues(
        checkStackInIssuesRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardIssuesApi.checkStackInIssues']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getYardIssues(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardIssueResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getYardIssues(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardIssuesApi.getYardIssues']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * YardIssuesApi - factory interface
 */
export const YardIssuesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = YardIssuesApiFp(configuration)
  return {
    /**
     *
     * @param {CheckStackInIssuesRequest} [checkStackInIssuesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkStackInIssues(
      checkStackInIssuesRequest?: CheckStackInIssuesRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<StackInIssueCheckResponse>> {
      return localVarFp
        .checkStackInIssues(checkStackInIssuesRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardIssues(options?: RawAxiosRequestConfig): AxiosPromise<Array<YardIssueResponse>> {
      return localVarFp.getYardIssues(options).then(request => request(axios, basePath))
    },
  }
}

/**
 * YardIssuesApi - object-oriented interface
 */
export class YardIssuesApi extends BaseAPI {
  /**
   *
   * @param {CheckStackInIssuesRequest} [checkStackInIssuesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkStackInIssues(
    checkStackInIssuesRequest?: CheckStackInIssuesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardIssuesApiFp(this.configuration)
      .checkStackInIssues(checkStackInIssuesRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getYardIssues(options?: RawAxiosRequestConfig) {
    return YardIssuesApiFp(this.configuration)
      .getYardIssues(options)
      .then(request => request(this.axios, this.basePath))
  }
}
